// | An action which can be triggered by the user.
import * as Data$dRecord from "../Data.Record/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const $WithExtraInitializer = (_1, _2) => ({tag: "WithExtraInitializer", _1, _2});
const WithExtraInitializer = value0 => value1 => $WithExtraInitializer(value0, value1);
const WithExtra = x => x;
const makeEmptyWithExtra = dictMakeEmpty => dictMakeEmpty1 => (
  {
    makeEmptyImpl: opts => {
      const $0 = dictMakeEmpty.makeEmptyImpl(opts);
      return () => {
        const subform1 = $0();
        const extra1 = dictMakeEmpty1.makeEmptyImpl({name: opts.name})();
        return {subform: subform1, extra: extra1};
      };
    }
  }
);
const isTextFieldWithExtra = dictIsTextField => ({textInput: v => dictIsTextField.textInput(v.subform)});
const initializeWithExtraInitia = dictInitialize => dictInitialize1 => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(subform1 => Specular$dInternal$dRIO.bindImpl(dictInitialize1.makeImpl(p)(opts))(extra1 => Specular$dInternal$dRIO.pureImpl({
      field: {subform: subform1.field, extra: extra1.field},
      init: iv => v => {
        const $0 = v._2;
        return Specular$dInternal$dRIO.bindImpl(subform1.init(iv)(v._1))(() => extra1.init(Restaumatic$dForm$dInternal.NoInitialValue)($0));
      }
    })))
  }
);
const hasFieldWithExtraTrue = () => dictIsSymbol => ({getFieldWithExtra: label => v => v1 => Data$dRecord.unsafeGet(dictIsSymbol.reflectSymbol(label))(v1.extra)});
const hasFieldWithExtraFalse = dictHasField => ({getFieldWithExtra: label => v => v1 => dictHasField.getField(label)(v1.subform)});
const dumpStateWithExtra = dictDumpState => dictDumpState1 => (
  {
    dumpState: v => Restaumatic$dForm$dInternal.dumpState_Record()(Restaumatic$dForm$dInternal.dumpStateRecordCons({reflectSymbol: () => "extra"})(Restaumatic$dForm$dInternal.dumpStateRecordCons({
      reflectSymbol: () => "subform"
    })(Restaumatic$dForm$dInternal.dumpStateRecordNil)(dictDumpState)()())(dictDumpState1)()()).dumpState(v)
  }
);
const addContextWithExtra = dictAddContext => dictAddContext1 => (
  {
    addContext: ctx => v => {
      const $0 = v.extra;
      const $1 = dictAddContext.addContext(ctx)(v.subform);
      return () => {
        $1();
        return dictAddContext1.addContext(ctx)($0)();
      };
    }
  }
);
const withExtra = WithExtraInitializer;
const subform = v => v.subform;
const hasErrorsWithExtra = dictHasErrors => ({displayedErrors: f => dictHasErrors.displayedErrors(f.subform)});
const isSelectFieldWithExtra = dictIsSelectField => (
  {
    selectWriteValue: f => dictIsSelectField.selectWriteValue(f.subform),
    selectReadValue: f => dictIsSelectField.selectReadValue(f.subform),
    selectGetOptions: f => dictIsSelectField.selectGetOptions(f.subform),
    selectTouch: f => dictIsSelectField.selectTouch(f.subform)
  }
);
const mergeWithExtra = dictMerge => (
  {
    merge: d => {
      const $0 = dictMerge.merge(d);
      return x => $0(x.subform);
    }
  }
);
const queryWithExtra = dictQuery => (
  {
    queryWith: s => {
      const $0 = dictQuery.queryWith(s);
      return x => $0(x.subform);
    }
  }
);
const queryWithExtra1 = dictQuery => ({queryImpl: x => dictQuery.queryImpl(x.subform)});
const getFieldWithExtra = dict => dict.getFieldWithExtra;
const hasFieldWithExtraRecord = () => dictHasFieldWithExtra => ({getField: label => dictHasFieldWithExtra.getFieldWithExtra(label)(Type$dProxy.Proxy)});
const extra = v => v.extra;
export {
  $WithExtraInitializer,
  WithExtra,
  WithExtraInitializer,
  addContextWithExtra,
  dumpStateWithExtra,
  extra,
  getFieldWithExtra,
  hasErrorsWithExtra,
  hasFieldWithExtraFalse,
  hasFieldWithExtraRecord,
  hasFieldWithExtraTrue,
  initializeWithExtraInitia,
  isSelectFieldWithExtra,
  isTextFieldWithExtra,
  makeEmptyWithExtra,
  mergeWithExtra,
  queryWithExtra,
  queryWithExtra1,
  subform,
  withExtra
};
